var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7485:93599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6249 3.95703C10.6249 3.61185 10.3451 3.33203 9.99992 3.33203C9.65474 3.33203 9.37492 3.61185 9.37492 3.95703V13.2946L6.05747 9.97731C5.81554 9.73539 5.42329 9.73539 5.18136 9.97731C4.93944 10.2192 4.93944 10.6115 5.18136 10.8534L9.56187 15.2339C9.8038 15.4758 10.196 15.4758 10.438 15.2339L14.8185 10.8534C15.0604 10.6115 15.0604 10.2192 14.8185 9.97731C14.5765 9.73539 14.1843 9.73539 13.9424 9.97731L10.6249 13.2947V3.95703Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0416 17.9154C16.3868 17.9154 16.6666 17.6355 16.6666 17.2904C16.6666 16.9452 16.3868 16.6654 16.0416 16.6654H3.95825C3.61307 16.6654 3.33325 16.9452 3.33325 17.2904C3.33325 17.6355 3.61307 17.9154 3.95825 17.9154H16.0416Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7485:93599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownload);
export default __webpack_public_path__ + "static/media/icn_download.0a5b4331905ffd9d8cf5d21e7afe8a43.svg";
export { ForwardRef as ReactComponent };